// ─────────────────────────────────────────────────────────
// SELECTRA TECHNOLOGIES — IMAGE LIBRARY
// External stock photography (Unsplash), grouped by subject.
// Swap any URL here for your own photography at any time —
// every component pulls images from this single file.
// ─────────────────────────────────────────────────────────

const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const images = {
  heroRooftop: u("photo-1508514177221-188b1cf16e9d"), // Solar panels on roof
  panelsField: u("photo-1509391366360-2e959784a276"), // Solar farm
  panelsCloseup: u("photo-1508514177221-188b1cf16e9d"), // Solar panels close
  engineerInstall: u("photo-1581092160607-ee22621dd758"), // Technician working
  solarSunset: u("photo-1497440001374-f26997328c1b"), // Solar sunset
  officeBuilding: u("photo-1497366216548-37526070297c"), // Modern building
  batteryRoom: u("photo-1581092160607-ee22621dd758"), // Battery/storage
  streetLight: u("photo-1508514177221-188b1cf16e9d"), // Street with solar
  ruralFarm: u("photo-1622397333673-e3e7d43a6e01"), // Rural landscape
  teamMeeting: u("photo-1600880292203-757bb62b4baf"), // Team meeting
  panelDetail: u("photo-1508514177221-188b1cf16e9d"), // Panel detail
  aerialPanels: u("photo-1548613053-22087dfcac5d"), // Aerial solar farm
};
